import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/stats/base/dists/weibull/cdf';
import __var_2__ from '@stdlib/stats/base/dists/weibull/ctor';
import __var_3__ from '@stdlib/stats/base/dists/weibull/entropy';
import __var_4__ from '@stdlib/stats/base/dists/weibull/kurtosis';
import __var_5__ from '@stdlib/stats/base/dists/weibull/logcdf';
import __var_6__ from '@stdlib/stats/base/dists/weibull/logpdf';
import __var_7__ from '@stdlib/stats/base/dists/weibull/mean';
import __var_8__ from '@stdlib/stats/base/dists/weibull/median';
import __var_9__ from '@stdlib/stats/base/dists/weibull/mgf';
import __var_10__ from '@stdlib/stats/base/dists/weibull/mode';
import __var_11__ from '@stdlib/stats/base/dists/weibull/pdf';
import __var_12__ from '@stdlib/stats/base/dists/weibull/quantile';
import __var_13__ from '@stdlib/stats/base/dists/weibull/skewness';
import __var_14__ from '@stdlib/stats/base/dists/weibull/stdev';
import __var_15__ from '@stdlib/stats/base/dists/weibull/variance';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace weibull
*/
var weibull = {};

/**
* @name cdf
* @memberof weibull
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/weibull/cdf}
*/
setReadOnly( weibull, 'cdf', __var_1__);

/**
* @name Weibull
* @memberof weibull
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/weibull/ctor}
*/
setReadOnly( weibull, 'Weibull', __var_2__);

/**
* @name entropy
* @memberof weibull
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/weibull/entropy}
*/
setReadOnly( weibull, 'entropy', __var_3__);

/**
* @name kurtosis
* @memberof weibull
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/weibull/kurtosis}
*/
setReadOnly( weibull, 'kurtosis', __var_4__);

/**
* @name logcdf
* @memberof weibull
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/weibull/logcdf}
*/
setReadOnly( weibull, 'logcdf', __var_5__);

/**
* @name logpdf
* @memberof weibull
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/weibull/logpdf}
*/
setReadOnly( weibull, 'logpdf', __var_6__);

/**
* @name mean
* @memberof weibull
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/weibull/mean}
*/
setReadOnly( weibull, 'mean', __var_7__);

/**
* @name median
* @memberof weibull
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/weibull/median}
*/
setReadOnly( weibull, 'median', __var_8__);

/**
* @name mgf
* @memberof weibull
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/weibull/mgf}
*/
setReadOnly( weibull, 'mgf', __var_9__);

/**
* @name mode
* @memberof weibull
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/weibull/mode}
*/
setReadOnly( weibull, 'mode', __var_10__);

/**
* @name pdf
* @memberof weibull
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/weibull/pdf}
*/
setReadOnly( weibull, 'pdf', __var_11__);

/**
* @name quantile
* @memberof weibull
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/weibull/quantile}
*/
setReadOnly( weibull, 'quantile', __var_12__);

/**
* @name skewness
* @memberof weibull
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/weibull/skewness}
*/
setReadOnly( weibull, 'skewness', __var_13__);

/**
* @name stdev
* @memberof weibull
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/weibull/stdev}
*/
setReadOnly( weibull, 'stdev', __var_14__);

/**
* @name variance
* @memberof weibull
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/weibull/variance}
*/
setReadOnly( weibull, 'variance', __var_15__);


// EXPORTS //
export default weibull;

export { __var_1__ as cdf, __var_2__ as Weibull, __var_3__ as entropy, __var_4__ as kurtosis, __var_5__ as logcdf, __var_6__ as logpdf, __var_7__ as mean, __var_8__ as median, __var_9__ as mgf, __var_10__ as mode, __var_11__ as pdf, __var_12__ as quantile, __var_13__ as skewness, __var_14__ as stdev, __var_15__ as variance};